import React from "react";

import { getFormErrorMessage } from "components/pages/measurement-devices/utils/utils";
import { InputNumber, InputNumberProps } from "primereact/inputnumber";
import { InputText, InputTextProps } from "primereact/inputtext";
import { ControllerRenderProps, FieldErrors, FieldValues } from "react-hook-form";
import { Dropdown, DropdownProps } from "primereact/dropdown";
import InputLabelWrapper from "../input-label-wrapper/InputLabelWrapper";

type ControllerInputProps<T extends FieldValues> = {
  errors: FieldErrors<T>;
  field: ControllerRenderProps<T, any>;
  label: string;
  col?: number;
};

export const ControllerTextInput = <T extends FieldValues>({
  field,
  errors,
  label,
  col,
  ...inputProps
}: ControllerInputProps<T> & InputTextProps) => {
  return (
    <InputLabelWrapper labelName={label} col={col ?? 6}>
      <InputText
        value={field.value ?? ""}
        onChange={e => {
          field.onChange(e.target.value);
        }}
        className="p-inputtext-sm"
        name={field.name}
        placeholder={inputProps.placeholder ?? label}
        {...inputProps}
      />
      {getFormErrorMessage(field.name, errors)}
    </InputLabelWrapper>
  );
};

export const ControllerNumberInput = <T extends FieldValues>({
  field,
  errors,
  label,
  col,
  ...inputProps
} : ControllerInputProps<T> & InputNumberProps) => {
  return (
    <InputLabelWrapper labelName={label} col={col ?? 6}>
      <InputNumber
        value={field.value}
        onChange={e => {
          field.onChange(e.value);
        }}
        className="p-inputtext-sm"
        name={field.name}
        placeholder={inputProps.placeholder ?? label}
        useGrouping={false}
        maxFractionDigits={2}
        {...inputProps}
      />
      {getFormErrorMessage(field.name, errors)}
    </InputLabelWrapper>
  );
};

export const ControllerDropdownInput = <T extends FieldValues>({
  field,
  errors,
  label,
  col,
  ...inputProps
} : ControllerInputProps<T> & DropdownProps) => {
  return (
    <InputLabelWrapper labelName={label} col={col}>
      <Dropdown
        value={field.value}
        onChange={e => field.onChange(e.value)}
        className="p-inputtext-sm"
        name={field.name}
        placeholder={inputProps.placeholder ?? label}
        {...inputProps}
      />
      {getFormErrorMessage(field.name, errors)}
    </InputLabelWrapper>
  );
};
